import { defineMessages } from 'react-intl';

export const BadgeMap = {
    RapidRegistration: 'RapidRegistration',
    RapidRegistrationThroughCheckin: 'RapidRegistration',
    SuccessRate: 'SchedulingHero',
    PatientRecall: 'SeeYouAgain',
    ResponseTime: 'SpeedyResponse',
};

export const LOCALIZED_NAMES = defineMessages({
    RapidRegistration: {
        id: 'Profile.Components.ProfileTab.Badges.RapidRegistration',
        defaultMessage: 'Rapid registration',
    },
    SchedulingHero: {
        id: 'Profile.Components.ProfileTab.Badges.SchedulingHero',
        defaultMessage: 'Scheduling hero',
    },
    SeeYouAgain: {
        id: 'Profile.Components.ProfileTab.Badges.SeeYouAgain',
        defaultMessage: 'See you again',
    },
    SpeedyResponse: {
        id: 'Profile.Components.ProfileTab.Badges.SpeedyResponse',
        defaultMessage: 'Speedy response',
    },
});

export const LOCALIZED_TOOLTIPS = defineMessages({
    RapidRegistration: {
        id: 'Profile.Components.ProfileTab.Badges.RapidRegistration.Tooltip',
        defaultMessage: 'Complete your forms online with this practice',
    },
    SchedulingHero: {
        id: 'Profile.Components.ProfileTab.Badges.SchedulingHero.Tooltip',
        defaultMessage: 'This practice keeps their schedule running smoothly',
    },
    SeeYouAgain: {
        id: 'Profile.Components.ProfileTab.Badges.SeeYouAgain.Tooltip',
        defaultMessage: 'Patients often return to this practice',
    },
    SpeedyResponse: {
        id: 'Profile.Components.ProfileTab.Badges.SpeedyResponse.Tooltip',
        defaultMessage: 'This practice confirms appointments quickly',
    },
});
